import { ImgHTMLAttributes, forwardRef } from "react";

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    alt: string;
    src: string;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(({ alt, src, ...props }, ref) => (
    // eslint-disable-next-line react/forbid-elements
    <img alt={alt} src={src} ref={ref} {...props} />
));

export default Image;
